import React, { Fragment, useState, useEffect, useContext } from 'react';
import TableBuilder, { ApiRequestBuilder } from '../../../GlobalComponents/Builders';
import { sortArrayByKeys, showRelativeTime } from '../../../GlobalComponents/Helpers';
import { AccountContext } from '../../../GlobalComponents/Authentication/Accounts';
import { Container, Row, Card, CardBody } from 'reactstrap'
import { Link } from 'react-router-dom';

const UserList = () => {

    const [userData, setData] = useState([]);
    const { isGlobal } = useContext(AccountContext);



    useEffect(() => {

        document.title = 'View Users'

        ApiRequestBuilder('usersGet', null, null, null, { fields: 'user_id,full_name,partner_name,email,date_created' })
            .then(function(results) {
                setData(results.data?.length > 0 ? sortArrayByKeys(results.data, [{ date_created: 'DESC' }, { partner_name: 'ASC' }]) : [])
            })
    }, []);

    return (
            <Fragment>
                <Row>
                    <Container>
                        <Card>
                        <CardBody>
                            <TableBuilder
                                data={userData}
                                title='List Users'
                                pageSize={25}
                                processing={false}
                                sortField={null}
                                subHeader={true}
                                columnsToSearch={['full_name', 'email', 'partner_name']}
                                columns = {[
                                    {
                                        name: 'Partner',
                                        selector: (row) => row.partner_name || '-',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '35%',
                                        omit: !isGlobal,
                                    },
                                    {
                                        name: 'Name',
                                        selector: (row) => row.full_name,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '35%',
                                    },
                                    {
                                        name: 'Email Address',
                                        selector: (row) => row.email,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Sign-up Date',
                                        selector: (row) => row.date_created ? showRelativeTime(row.date_created) : '-',
                                        sortable: true,
                                        center: true,
                                        maxWidth: '20%',
                                    },
                                    {
                                        name: 'Manage',
                                        selector: (row) => <Link to={`${process.env.PUBLIC_URL}/users/` + row.user_id}>View / Edit</Link>,
                                        sortable: true,
                                        center: true,
                                        omit: false
                                    }
                                ]}
                            />
                        </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Fragment>
    );
};

export default UserList;